import { render, staticRenderFns } from "./transacions.vue?vue&type=template&id=12409f38&"
import script from "./transacions.vue?vue&type=script&lang=js&"
export * from "./transacions.vue?vue&type=script&lang=js&"
import style0 from "./transacions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports